export default __webpack_public_path__ + "static/B0183-34e2d864c314fdc4f223d722e731345f.png";